
const developmentRouter = [
	// {
	// 	"id": 1,
	// 	"name": "客户管理",
	// 	"url": 'PageUser/Index/Index',
	// 	"langcode": 'PageUser',
	// 	"openStyle": 0,
	// 	"icon": "icon-windows",
	// 	"children": []
	// },
	// {
	// 	"id": 2,
	// 	"name": "会员管理",
	// 	"url": 'PageMember/Index/Index',
	// 	"langcode": 'PageMember',
	// 	"openStyle": 0,
	// 	"icon": "icon-windows",
	// 	"children": []
	// },
	// {
	// 	"id": 3,
	// 	"name": "系统设置",
	// 	"url": 'PageSettings/Index/Index',
	// 	"langcode": 'PageSettings',
	// 	"openStyle": 0,
	// 	"icon": "icon-windows",
	// 	"children": []
	// },
	{
		"id": 3,
		"name": "权限管理",
		"url": "PagenSystem/Zymenu/Index",
		"langcode": 'PagenSystem',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
	// {
	// 	"id": 4,
	// 	"name": "员工管理",
	// 	"url": 'PagenSystem/Astaff/Index',
	// 	"langcode": 'PageSettings',
	// 	"openStyle": 0,
	// 	"icon": "icon-windows",
	// 	"children": []
	// },
]
const developmentRouterClient = [
	{
		"id": 9,
		"name": "权限管理",
		"url": "PagenSystem/ZmenuClient/Index",
		"langcode": 'PagenSystem',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
]
const userRouter = [
	{
		"id": 4,
		"name": "产品管理",
		"url": "PageProducts/Index",
		"langcode": 'PageProducts',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
	{
		"id": 5,
		"name": "联系人管理",
		"url": "PageContacts/Index",
		"langcode": 'PageContacts',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
	{
		"id": 7,
		"name": "文件管理",
		"url": "PageFile/Index",
		"langcode": 'PageFile',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
	{
		"id": 8,
		"name": "会员管理",
		"url": "PageMembership/Index",
		"langcode": 'PageMembership',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
]
const userRouterSub = [
	{
		"id": 4,
		"name": "产品管理",
		"url": "PageProducts/Index",
		"langcode": 'PageProducts',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
	{
		"id": 5,
		"name": "联系人管理",
		"url": "PageContacts/Index",
		"langcode": 'PageContacts',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
	{
		"id": 7,
		"name": "文件管理",
		"url": "PageFile/Index",
		"langcode": 'PageFile',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
]
const userRouterCompany = [
	{
		"id": 4,
		"name": "产品管理",
		"url": "PageProducts/Index",
		"langcode": 'PageProducts',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
	{
		"id": 5,
		"name": "联系人管理",
		"url": "PageContacts/Index",
		"langcode": 'PageContacts',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
	{
		"id": 6,
		"name": "账号管理",
		"url": "PageAccounts/Index",
		"langcode": 'PageAccounts',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
	{
		"id": 7,
		"name": "文件管理",
		"url": "PageFile/Index",
		"langcode": 'PageFile',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
	{
		"id": 8,
		"name": "会员管理",
		"url": "PageMembership/Index",
		"langcode": 'PageMembership',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	},
]
const userRouterAccounts = [
	{
		"id": 6,
		"name": "账号管理",
		"url": "PageAccounts/Index",
		"langcode": 'PageAccounts',
		"openStyle": 0,
		"icon": "icon-windows",
		"children": []
	}
]
const ISCLOSEMENU = true // 是否开起生成环境，菜单页屏蔽
const ADMIN_NAME = ['13735725151','13000000000'] // 是否开起生成环境，菜单页屏蔽(搭配上面这个)，只有当前登录用户才显示菜单配置页
export {
	ISCLOSEMENU,
	ADMIN_NAME,
	developmentRouter,
	developmentRouterClient,
	userRouter,
	userRouterSub,
	userRouterCompany,
	userRouterAccounts
}